import IcAddReaction from "@assets/reactions/add-reaction.svg";
import { reactionCount } from "@helper/utils";
import { ReactionProp } from "@typings/Reactions";
import type { ReactElement } from "react";

import { getReactionGif } from "./helper/getReactionGif";

export type ArticleReactionsProps = {
  reactions: ReactionProp[];
  reactionsUser: string;
  limit?: 1 | 2;
  referer?: string;
  variant?: "default" | "small";
};

export const ArticleReactions = ({
  reactions,
  reactionsUser,
  limit = 2,
  referer = "article",
  variant = "default",
}: ArticleReactionsProps): ReactElement => {
  if (reactions.length === 0) {
    return (
      <span key={`reaction-empty-${referer}`} data-testid="no-reaction"></span>
    );
  }

  const totalReactions =
    reactions.reduce((sum, reaction) => sum + reaction.count, 0) || 0;

  if (totalReactions === 0) {
    return (
      <div
        className={`w-[40px] flex items-center gap-0.5 rounded-[50px] border-blue-400 border py-2 px-2 ${variant === "small" ? "h-8" : ""}`}
      >
        <img
          width={24}
          height={24}
          src={IcAddReaction}
          data-testid="add-reaction"
          alt="add-reaction"
        />
      </div>
    );
  }

  const topReactions = [...reactions]
    .filter((reaction) => reaction.count > 0)
    .sort((a, b) => b.count - a.count)
    .slice(0, limit);

  return (
    <div
      className={`w-fit flex items-center justify-center gap-0.5 rounded-[50px] border py-2.5 px-3
      ${reactionsUser && reactionsUser !== "0" ? "border-blue-400" : "border-grey-350"}
      ${variant === "small" ? "h-8" : ""}`}
    >
      <div className="flex items-center">
        {topReactions.map((reaction, index) => (
          <span
            key={`reactions-span-${referer}-${reaction.id}`}
            data-testid={`reaction-${index}`}
            className={index > 0 ? "-ml-1" : ""}
          >
            <img
              src={getReactionGif(reaction.id)}
              alt={reaction.text}
              width={20}
            />
          </span>
        ))}
      </div>
      <span
        className={`text-sm ${reactionsUser && reactionsUser !== "0" ? "text-blue-400" : "text-grey-350"} font-semimedium leading-[150%]`}
      >
        {reactionCount(totalReactions)}
      </span>
    </div>
  );
};
